// src/components/FAQ/FAQ.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQ.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqData = [
    {
      category: 'General Questions',
      questions: [
        {
          q: 'What is AICIS?',
          a: 'AICIS stands for the Africa Infrastructure Climate Change and Investment Summit. It is a premier event bringing together key stakeholders from government, private sector, and civil society to discuss and promote sustainable infrastructure development, climate change mitigation, and investment opportunities across Africa.'
        },
        {
          q: 'Who should attend AICIS?',
          a: 'AICIS is ideal for policymakers, business leaders, investors, environmental experts, academics, and other professionals involved in infrastructure development, climate change initiatives, and investment projects in Africa.'
        }
      ]
    },
    {
      category: 'Registration and Attendance',
      questions: [
        {
          q: 'How do I register for the summit?',
          a: 'You can register for AICIS through our official website. Early registration is encouraged to secure your spot and take advantage of early bird discounts.'
        },
        {
          q: 'What are the registration fees?',
          a: 'The registration fees vary based on the type of participant (e.g., delegate, exhibitor, sponsors, etc) and the registration date. Please refer to the registration page on our website for detailed pricing information.'
        },
        {
          q: 'What is included in the registration fee?',
          a: 'The registration fee includes access to all summit sessions, networking events, exhibition areas, conference materials, and meals during the summit days.'
        },
        {
          q: 'Is there a deadline for registration?',
          a: 'Yes, the registration deadline is 24 hours before the start of the summit. We recommend registering early as spaces are limited.'
        }
      ]
    },
    {
      category: 'Program and Sessions',
      questions: [
        {
          q: 'What topics will be covered at the summit?',
          a: 'The summit will cover a wide range of topics, including sustainable infrastructure development, climate change mitigation strategies, renewable energy, investment opportunities, public-private partnerships, and technological innovations.'
        },
        {
          q: 'Who are the speakers at AICIS?',
          a: 'The summit will feature a diverse lineup of speakers, including high-level government officials, industry leaders, renowned academics, and experts from international organizations. A full list of confirmed speakers can be found on our website.'
        },
        {
          q: 'Can I submit a proposal to speak or present a paper at the summit?',
          a: 'Yes, we welcome proposals for presentations, workshops, and panel discussions. Please submit your proposal through our Call for Papers page by clicking on Submit Call for Paper Proposal.'
        }
      ]
    },
    {
      category: 'Sponsorship and Exhibition',
      questions: [
        {
          q: 'How can my organization become a sponsor of AICIS?',
          a: 'Sponsorship opportunities are available at various levels. Please click at Sponsorship Package for a detailed sponsorship prospectus and to discuss customized sponsorship packages.'
        },
        {
          q: 'Can my company exhibit at the summit?',
          a: 'Yes, there are exhibition spaces available for companies and organizations to showcase their products, services, and initiatives. Please visit our Exhibitors page https://abvig.org/exhibitors/ for more information and to book a booth.'
        }
      ]
    },
    {
      category: 'Logistics and Accommodations',
      questions: [
        {
          q: 'Are there discounted hotel rates for summit attendees?',
          a: 'Yes, we have negotiated special rates with several hotels near the summit venue. Please visit our Accommodations page for a list of partner hotels and booking instructions.'
        },
        {
          q: 'How can I get to the summit venue?',
          a: 'Detailed information on transportation options, including airport transfers, public transit, and parking, is available on our Travel Information page.'
        },
        {
          q: 'What should I do if I have specific accessibility needs?',
          a: 'Please contact our event team at www.abvig.org/contact with your specific requirements, and we will do our best to accommodate your needs.'
        }
      ]
    },
    {
      category: 'Contact Information',
      questions: [
        {
          q: 'Who can I contact for more information?',
          a: 'For general inquiries, please reach us at www.abvig.org/contact. For specific questions regarding registration, sponsorship, or speaking opportunities, please refer to the appropriate contact information on our website.'
        }
      ]
    }
  ];

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <div className="faq-hero">
        <div className="faq-hero-overlay"></div>
        <div className="faq-hero-content">
          <span className="faq-badge">FAQ</span>
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to the most common questions about AICIS 2026</p>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="faq-container">
        {faqData.map((category, catIndex) => (
          <div className="faq-category" key={catIndex}>
            <div className="faq-category-header">
              <span className="faq-category-number">{String(catIndex + 1).padStart(2, '0')}</span>
              <h2>{category.category}</h2>
            </div>
            <div className="faq-list">
              {category.questions.map((item, qIndex) => {
                const globalIndex = faqData.slice(0, catIndex).reduce((acc, curr) => acc + curr.questions.length, 0) + qIndex;
                return (
                  <div 
                    className={`faq-item ${activeIndex === globalIndex ? 'active' : ''}`}
                    key={qIndex}
                    onClick={() => toggleFAQ(globalIndex)}
                  >
                    <div className="faq-question">
                      <span className="faq-q-icon">Q</span>
                      <p>{item.q}</p>
                      <span className="faq-toggle">{activeIndex === globalIndex ? '−' : '+'}</span>
                    </div>
                    <div className={`faq-answer ${activeIndex === globalIndex ? 'open' : ''}`}>
                      <div className="faq-answer-inner">
                        <span className="faq-a-icon">A</span>
                        <p>{item.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Footer Note */}
        <div className="faq-footer-note">
          <p>
            Still have questions? Contact us at <a href="mailto:aicisnigeria@abvig.org">aicisnigeria@abvig.org</a> 
            or call <a href="tel:+2347032941519">+234 703 294 1519</a>
          </p>
        </div>

        {/* Back Button */}
        <div className="faq-back">
          <Link to="/" className="back-button">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default FAQ;